import React from 'react';
import { PlaybackProviderProps } from './context/PlaybackContext';
import { PlayerProvider } from './context/PlayerContext';
import PlayerUi, { PlayerUiProps } from './PlayerUi';

type PickedProviderProps = Pick<
  PlaybackProviderProps,
  'extendedPlayback' | 'onEnded' | 'onInteraction' | 'onPause' | 'onPlaying'
>;

export interface PlayerProps extends PickedProviderProps, PlayerUiProps {
  animatePreview?: boolean;
  autoplay?: boolean;
  loop?: boolean;
}

interface PlayerComponent extends React.FC<PlayerProps> {
  Provider: typeof PlayerProvider;
  Ui: typeof PlayerUi;
}

const Player: PlayerComponent = ({
  animatePreview,
  autoplay,
  className,
  controls,
  extendedPlayback,
  loop,
  onEnded,
  onInteraction,
  onPause,
  onPlaying,
  visualization,
}) => (
  <PlayerProvider
    {...{
      animatePreview,
      autoplay,
      extendedPlayback,
      loop,
      onEnded,
      onInteraction,
      onPause,
      onPlaying,
    }}
  >
    <PlayerUi {...{ className, controls, visualization }} />
  </PlayerProvider>
);

Player.Provider = PlayerProvider;
Player.Ui = PlayerUi;

export default Player;
